import React from 'react';
import FullStatus from './FullStatus';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const PlanFullStatus = ({ status, trend, progress, startDate, endDate, className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <FullStatus
            label={t('Plan Status')}
            status={status}
            trend={trend}
            progress={progress}
            startDate={startDate}
            endDate={endDate}
            className={className}
        />
    );
};

export default PlanFullStatus;
